// extracted by mini-css-extract-plugin
export default {"button":"MenuItem_button__lk3YZ","text":"MenuItem_text__zx44F"};